/* unplugin-vue-components disabled */import { ElTimePicker as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/time-picker/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    rangeSeparator: {
      type: String,
      default: '至'
    },
    startPlaceholder: {
      type: String,
      default: '开始时间'
    },
    endPlaceholder: {
      type: String,
      default: '结束时间'
    },
    startValue: {
      type: [String, Number, Date],
      default: ''
    },
    endValue: {
      type: [String, Number, Date],
      default: ''
    },
    valueFormat: {
      type: String,
      default: 'timestamp'
    },
    disabledTime: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:startValue', 'update:endValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const timeRange = ref([]);
    watch(() => [props.startValue, props.endValue], () => {
      console.log(props.startValue, 'props.startValue');
      const baseDate = '2022-01-01 ';
      if (props.startValue && props.endValue) {
        timeRange.value = [new Date(`${baseDate}${props.startValue}`), new Date(`${baseDate}${props.endValue}`)];
        console.log(timeRange.value, 'timeRange.value');
      }
    }, {
      immediate: true
    });
    const emits = __emit;
    watch(() => timeRange.value, val => {
      console.log('val', val);
      if (val && val.length === 2) {
        emits('update:startValue', props.valueFormat === 'timestamp' ? dayjs(val[0]).unix() : dayjs(val[0]).format(props.valueFormat));
        emits('update:endValue', props.valueFormat === 'timestamp' ? dayjs(val[1]).unix() : dayjs(val[1]).format(props.valueFormat));
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_time_picker = __unplugin_components_0;
      return _openBlock(), _createBlock(_component_el_time_picker, {
        modelValue: _unref(timeRange),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(timeRange) ? timeRange.value = $event : null),
        "is-range": "",
        disabled: __props.disabledTime,
        "range-separator": __props.rangeSeparator,
        "start-placeholder": __props.startPlaceholder,
        "end-placeholder": __props.endPlaceholder
      }, null, 8, ["modelValue", "disabled", "range-separator", "start-placeholder", "end-placeholder"]);
    };
  }
});